<template>
    <div>
        <p v-if="loading">Loading consented channels...</p>
        <div v-else>
            <div v-if="consentedChannels.length > 0">
                <div v-for="channel in consentedChannels" :key="channel.id">
                    <dl class="row mb-2">
                        <dt v-if="recipient.type == 'Participant'">
                            {{ channel.name }}
                            <span v-if="recipient.preferred_channel_id==channel.id" class="text-success">preferred</span>
                            <button v-else class="btn btn-link p-0" title="Set preferred" @click="editPreferredChannel(channel.id)">set as preferred</button>
                        </dt>
                        <dt v-if="recipient.type == 'PracticeStaff'">
                            {{ channel.name }}
                        </dt>
                        <dd>{{ channel.address }}</dd>
                    </dl>
                </div>
            </div>
            <p v-else>No consented channels found</p>
        </div>
        <div v-if="['true','false'].includes(canReceiveEcomm)" class="row mt-2">
            <div class="col d-flex justify-content-end flex-column align-items-end">
                <button class="btn btn-primary btn-sm py-0 px-1" @click="createCommunicationConsent">
                    Update E-Communication Consent
                </button>
                <div v-if="error" class="alert alert-danger small mb-0 mt-1 py-1 px-2" role="alert">
                    {{ error }}
                </div>
                <!-- <p v- if = "error" class="text-danger small mb-0 mt-1">{ { error } }</p> -->
            </div>
        </div>
    </div>
</template>

<script setup>
    import { ref, computed } from 'vue'
    import { storeToRefs } from 'pinia'
    import { useChannelsStore } from '../../stores/channels-store'
    import ChannelsModal from './ChannelsModal.vue'

    const { channels, loading, error, recipient } = storeToRefs(useChannelsStore())
    const { setRecipient, fetchChannels, fetchCommLogs, setPreferredChannel, editPreferredChannel, createCommunicationConsent } = useChannelsStore()
    const props = defineProps(['recipientType', 'recipientId', 'preferredChannelId', 'canReceiveEcomm', 'user'])

    const consentedChannels = computed(() => {
      return channels.value ? channels.value.filter(channel => channel.is_consented_type == 1) : [];
    })

    setRecipient(props.recipientType, props.recipientId)
    setPreferredChannel(props.preferredChannelId)

    fetchChannels()

    // const showUpdateECommunicationConsentButton = computed(() => {
    //     return (
    //         props.user &&
    //         props.user.roles &&
    //         props.user.roles.length > 0 &&
    //         props.user.roles[0].name === "Interview Team"
    //     );
    // });
</script>